import { render, staticRenderFns } from "./SignAndAuthKeys.vue?vue&type=template&id=5199f4b2&scoped=true&"
import script from "./SignAndAuthKeys.vue?vue&type=script&lang=ts&"
export * from "./SignAndAuthKeys.vue?vue&type=script&lang=ts&"
import style0 from "./SignAndAuthKeys.vue?vue&type=style&index=0&id=5199f4b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5199f4b2",
  null
  
)

export default component.exports